<template>
  <!-- App -->
   <f7-app :params="f7params" :class="[ layoutClass, themeClass ]">
    <template v-if="AppConfig.Subscription_Id != 0">
      <!-- Statusbar -->
        <f7-statusbar :style="getSBarStyle"></f7-statusbar>
        <app-loader v-show="loading"></app-loader>
        <!-- Main View -->
        <!-- <f7-view id="main-view" main :iosDynamicNavbar="false"></f7-view> -->
         <f7-view id="main-view" url="/" :main="true" :iosDynamicNavbar="false" :class="addSafeAreaClass()"></f7-view>
        <!-- More Menu -->
        <app-more-menu v-if="MainMenuLayout !== 2"></app-more-menu>
        <app-Comment-form></app-Comment-form>
        <app-user-registration></app-user-registration>
        <app-user-profile-edit></app-user-profile-edit>
        <app-side-menu v-if="MainMenuLayout === 2"></app-side-menu>
    </template>
    <template v-else>
      <app-loader v-show="true"></app-loader>
    </template>
  </f7-app>
</template>

<script>
import queryString from 'query-string'
import { mapGetters, mapActions } from 'vuex'
import { isPhoneGap } from '@/modules/util/util'
import * as phonegapHelper from '@/modules/phonegap/index'
import * as Helper from '@/modules/helper/index'
import loader from '@/components/shared/Loader.vue'
import Home from './components/home/Home.vue'
import DeviceInfo from '@/modules/util/deviceInfo';
import routes from './routes.js'
import MediaClass, {CALLING_STATE, MEDIA_STATE} from '@/modules/radio-stream/index'

export default {
  components: {
    appLoader: loader,
    appHome: Home
  },
  data() {
    return {
      layoutClass: 'layout-onAirDefault',
      themeClass: 'theme-onAirDefault',
      Subscription_Id: 0,
      f7params: {
        id: 'onair-web-app', // App bundle ID
        name: 'WebApp', // App name
        theme: DeviceInfo.isAndroid ? 'md' : 'ios', // 'md', // Automatic theme detection ios, md, auto
        // App routes
        routes,
        view: {
          pushState: true,
          uniqueHistory: true,
          preloadPreviousPage: false,
          iosSwipeBack: false,
          pushStateRoot: window.location.pathname + window.location.search
        },
        touch: {
          tapHold: true,
          disableContextMenu: false
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'loading',
      'ActiveModule',
      'DesignSettings',
      'MainMenu',
      'AppConfig',
      'MainMenuLayout',
      'ChannelmsgCount',
      'ActiveChannelId',
      'channelNotificationObj',
      'AudioPlayersInfo',
      'Stream'
    ]),
    getSBarStyle() {
      if (this.MainMenu && this.MainMenu.TitleBarVisible) {
        let hashCode = Helper.HashCodeFromInt(this.DesignSettings.AppThemeColor)
        let colorrgb = Helper.hexToRgb(hashCode)
        return `background: rgba(${colorrgb} ,${this.MainMenu.TitleBarOpacity})`
      } else {
        if (Helper.IsDevSim()) {
          let hashCode = Helper.HashCodeFromInt(this.DesignSettings.AppThemeColor)
          let colorrgb = Helper.hexToRgb(hashCode)
          return `background: rgba(${colorrgb});
          height: 28px !important;`
        }
      }
      // else {
      //   if (Helper.IsDevSim()) {
      //     let hashCode = Helper.HashCodeFromInt(this.DesignSettings.AppThemeColor)
      //     let colorrgb = Helper.hexToRgb(hashCode)
      //     return `background: rgba(${colorrgb});
      //     height: 28px !important;`
      //   }
      // }
    }
  },
  watch: {
    ActiveModule: function(value, oldvalue) {
      if (value !== 'back') {
        this.$f7.panel.close('right')
        this.$f7.view.main && this.$f7.view.main.router.navigate(value)
      } else {
        this.$f7.view.main.router.navigate(this.$f7.view.main.router.previousRoute.path)
      }
    }
  },
  async created() {
    this.$showLoader()
    this.setDevsimloaded(false)
    this.Subscription_Id = window.appConfig.Subscription_Id
    if (isPhoneGap()) {
      await this.loadLocalAppConfigData(this.Subscription_Id)
    } else {
      await this.loadAppConfig(this.Subscription_Id).then(() => {
        this.setDevsimloaded(true)
      }).catch(err => {
        console.log('appConfig error', err)
        this.$hideLoader()
      })
    }

    if (window.appConfig) {
      delete window.appConfig.MainMenu
      delete window.appConfig.Modules
      delete window.appConfig.DesignSettings
    }
    this.$store.commit('SET_APPCONFIG', window.appConfig)
    delete window.appConfig
    const params = queryString.parse(location.search)
    if (params.devsim === 'true') {
      let initialStore = window.localStorage.getItem('initialStore')
      let selectedDevice = window.localStorage.getItem('selectedDevice')
      selectedDevice = selectedDevice !== 'null' ? selectedDevice : params.device
      if (selectedDevice !== 'null' && selectedDevice !== null) {
        this.$store.commit('setActiveDevice', selectedDevice)
      }
      if (initialStore !== 'null' && initialStore !== null) {
        let cloneStore = JSON.parse(initialStore)
        this.$store.state.appConfig = cloneStore.appConfig
        this.$store.state.ContentPage.ContentPage = cloneStore.ContentPage.ContentPage
        window.localStorage.setItem('initialStore', null)
        window.localStorage.setItem('selectedDevice', null)
        this.$store.commit('SET_APPCONFIG', this.$store.state.appConfig.AppConfig)
        this.$store.commit('SET_CONTENT_PAGES', this.$store.state.ContentPage.ContentPage)
      }
      let context = document.html || document.getElementsByTagName('html')[0]
      if (this.$store.state.appConfig.selectedDevice === 'devsimiPhone5' || this.$store.state.appConfig.selectedDevice === 'devsimiPhone6') {
        context.classList.add('with-statusbar')
      } else {
        context.classList.remove('with-statusbar')
      }
    } else {
      //Helper.addStatusBarInHtml('default-statusbar')
      if (isPhoneGap()) {
        this.initializeWebRadioPlayers()
      }
    }
  },
  mounted() {
    let $this = this
    if (isPhoneGap()) {
      if (window.NotificationData && window.NotificationData.wasTapped) {
        $this.onNotificationRecived(window.NotificationData)
      }
       if (window.NotificationData && window.NotificationData.additionalData && window.NotificationData.additionalData.coldstart) {
        this.onNotificationRecived(window.NotificationData)
      }
      if(Helper.IsValid(cordova.plugins) && Helper.IsValid(cordova.plugins.firebase)) {
        cordova.plugins.firebase.messaging.onBackgroundMessage(function(payload) {
          $this.OnFcmNotificationBackground(payload)
       });
        cordova.plugins.firebase.messaging.onMessage(function(payload) {
          $this.OnFcmNotificationForeground(payload)
        });
      }
      if (this.$notification) {
        this.$notification.on('notification', data => {
          this.onNotificationRecived(data)
        })
      }
    }
    this.initLanguage()
    this.$hideLoader()
  },
  methods: {
    ...mapActions([
      'loadLocalAppConfigData',
      'loadAppConfig',
      'initLanguage',
      'setChannelmsgCount',
      'updateAudioPlayersInfo',
      'loadRadioStream',
      'loadRadioStreamLocalData',
      'getUrlfromPls',
      'setDevsimloaded'
    ]),
    addSafeAreaClass () {
      return (Helper.IsDevSim()) ? 'is-dev-sim' : ''
    },
    convertBoolean(value) {
      return Helper.IsValid(value) ? Helper.convertBoolean(value) : false
    },
    OnFcmNotificationBackground(notificationData) {
      if (notificationData.NavigationUrl) {
        setTimeout(() => {
            this.$f7.views.main.router.navigate(notificationData.NavigationUrl) // this.$f7.mainView.router.load({url: notificationData.NavigationUrl})
          }, 1000)
      }
      if (notificationData.ChannelId !==  '00000000-0000-0000-0000-000000000000' && notificationData.SubscriptionModuleId !== "0" && this.ActiveChannelId !== notificationData.ChannelId) {
        this.handleMessageCounts(notificationData.ChannelId, notificationData.SubscriptionModuleId)
      }
    },
    OnFcmNotificationForeground(notificationData) {
      if (notificationData.NavigationUrl) {
      // if app is in foreground and not in active channel send notification, increase badge count
        if (notificationData.SubscriptionModuleId !== "0" && this.ActiveChannelId !== notificationData.ChannelId) {
          this.SendNotificationAndRedirect(notificationData.NavigationUrl, notificationData.title, notificationData.message, notificationData.image)
          this.handleMessageCounts(notificationData.ChannelId, notificationData.SubscriptionModuleId)
        } else if (notificationData.ChannelId ===  '00000000-0000-0000-0000-000000000000'){
          // if app is in foreground and notification is not for chat module
          this.SendNotificationAndRedirect(notificationData.NavigationUrl, notificationData.title, notificationData.message, notificationData.image)
        }
      }
    },
    onNotificationRecived(notificationData) {
      if (notificationData.additionalData) {
         if (notificationData.additionalData.foreground) {
            if(notificationData.message && notificationData.message.length > 150) {
              notificationData.message = notificationData.message.substring(0, 150) + '...'
            }
            if (notificationData.additionalData.NavigationUrl) {
              // if app is in foreground and not in active channel send notification, increase badge count
              if (notificationData.additionalData.SubscriptionModuleId !== "0" && this.ActiveChannelId !== notificationData.additionalData.ChannelId) {
                this.SendNotificationAndRedirect(notificationData.additionalData.NavigationUrl, notificationData.title, notificationData.message, notificationData.image)
                this.handleMessageCounts(notificationData.additionalData.ChannelId, notificationData.additionalData.SubscriptionModuleId)
              } else if (notificationData.additionalData.ChannelId ===  '00000000-0000-0000-0000-000000000000'){
                // if app is in foreground and not in notification is not for chat module
                this.SendNotificationAndRedirect(notificationData.additionalData.NavigationUrl, notificationData.title, notificationData.message, notificationData.image)
              }
            }
          } else {
            // if app is in background for both chat and push message send notification, redirect to navigation url
            if (notificationData.additionalData.NavigationUrl) {
              if (notificationData.additionalData.SubscriptionModuleId !== "0" && this.ActiveChannelId !== notificationData.additionalData.ChannelId) {
                this.handleMessageCounts(notificationData.additionalData.ChannelId, notificationData.additionalData.SubscriptionModuleId)
              }
              setTimeout(() => {
                this.$f7.views.main.router.navigate(notificationData.additionalData.NavigationUrl) // this.$f7.mainView.router.load({url: notificationData.additionalData.NavigationUrl})
              }, 1000)
            }
         }
      } else {
        // if tapped on notification redirect to navigation url for each case
        if (notificationData.wasTapped) {
          if(notificationData.message && notificationData.message.length > 150) {
            notificationData.message = notificationData.message.substring(0, 150) + '...'
          }
          if (notificationData.NavigationUrl) {
            setTimeout(() => {
              this.$f7.views.main.router.navigate(notificationData.NavigationUrl) // this.$f7.mainView.router.load({url: notificationData.NavigationUrl})
            }, 1000)
            // chat module count calculated
            if (notificationData.SubscriptionModuleId !== "0" && this.ActiveChannelId !== notificationData.ChannelId) {
              this.handleMessageCounts(notificationData.ChannelId, notificationData.SubscriptionModuleId)
            }
          }
          } else {
            if (notificationData.NavigationUrl) {
                  this.SendNotificationAndRedirect(notificationData.NavigationUrl, notificationData.title, notificationData.message, notificationData.image)
                // chat module count calculated
              if (notificationData.SubscriptionModuleId !== "0" && this.ActiveChannelId !== notificationData.ChannelId) {
                this.handleMessageCounts(notificationData.ChannelId, notificationData.SubscriptionModuleId)
              }
            }
          }
      }
      delete window.NotificationData
    },
    handleMessageCounts (channelId, subscriptionModuleId) {
      let channelmsgCount = this.ChannelmsgCount
      if(channelmsgCount.length > 0 && channelmsgCount.find(x => x.channelId === channelId)) {
        let clonObj = channelmsgCount.map(x => {
          if (x.channelId === channelId) {
            x.count = x.count + 1
          }
          return x
        })
        this.setChannelmsgCount(clonObj)
      } else {
        channelmsgCount.push({'count' : 1, 'channelId': channelId, 'subscriptionModuleId': parseInt(subscriptionModuleId), 'subscriptionId': parseInt(this.AppConfig.Subscription_Id)})
        this.setChannelmsgCount(channelmsgCount)
      }
    },
    SendNotificationAndRedirect (path, title, message, pictureUrl) {
      let f7instance = this.$f7
      this.$f7.notification.create({
          title: title,
          subtitle: message,
          closeOnClick: true,
          closeButton: true,
          closeTimeout: 5000,
          on: {
            click: function () {
              path === '/home' ? f7instance.views.main.router.navigate('/', {reloadAll: true})  : f7instance.views.main.router.navigate(path)
            }
          },
        }).open()
    },
    async initializeWebRadioPlayers () {
      try {
        let modulesItems = this.AppConfig.Modules ? this.AppConfig.Modules.Items : null
        let radioModules = modulesItems ? modulesItems.filter(x => x.Module_Id == 34) : null
        let pList = []
        // let player = null
        if (radioModules && radioModules.length > 0) {
          for (let index = 0; index < radioModules.length; index++) {
            let radioModule = radioModules[index];
            await this.loadRadioStreamLocalData(radioModule.Id)
            await this.loadRadioStream(radioModule.Id)
            if (!Helper.IsNullOrEmpty(this.Stream.StreamURL)) {
              let url = await this.getformattedURL(this.Stream.StreamURL)
              let player = new MediaClass(url, radioModule.Id)
              player.callingState = 0
              player.play()
              pList.push(player)
            }
          }
          this.updateAudioPlayersInfo(pList)
        }
      } catch (e) {
        console.log('initializeWebRadioPlayers', e)
      }
    },
    async getformattedURL(url) {
      let URL = ''
      if (!Helper.IsNullOrEmpty(url)) {
        URL = url
        if (URL.includes('.pls')) {
          let res = await this.getUrlfromPls(URL)
          let xhrDoc = res
          var pls = {}
          // split into lines
          pls.Entries = xhrDoc.split('\n')
          // Entry 0 is [playlist]
          // Entry 1 is NumberOfEntries=n
          pls.Count = pls.Entries[1].split('=')[1]
          // Entry 2,3,4 = File#=,Title#=,Length#=
          // repeat from 1 to NumberOfEntries
          pls.Items = []
          pls.curItem = 0
          pls.listOk = true
          let c = 2
          for (var i = 0; i < pls.Count; i++) {
            pls.Items.push({
              file: pls.Entries[i + c].split('=')[1],
              title: pls.Entries[i + c + 1].split('=')[1],
              length: pls.Entries[i + c + 2].split('=')[1]
            })
            c = c + 2
          }
          URL = pls.Items[0].file
        }
      }
      return URL
    }
  }
}
</script>
<style>


</style>



// WEBPACK FOOTER //
// src/app.vue